import AppWebApiUtilities from './app-web-api-utilities.js';
import axios from "axios";
import "magnific-popup";
import slick from  '../vendors/slider.min';

import $ from 'jquery';

class FloorPlans {

	constructor() {
		this.filters = {
			"condo": null,
			"price": null,
			"product-type": null,
			"view": null,
		}

		this.myListFloorPlanIds = [];
		this.myListFloorPlans = {};

		this.floorPlanToRemove = null;

		this.selects = {};
		this.allFloorplans = {};
		this.filteredFloorplans = [];
		this.activeFloorPlan = {};
		this.floorPlansFound = true;
		this.activeFloorPlanIndex = 1;
		this.activeLanguage = BJZM_DATA.current_language;
		this.init();
		this.setSelects();
	}

	init() {
		this.appWebApiUtilities = new AppWebApiUtilities({
			callBack: this.handleData.bind(this)
		});

	}

	getUrlVars() {
		var vars = {};
		var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
			vars[key] = value;
		});
		return vars;
	}

	setSelects() {


		function iformat(icon) {
			var originalOption = icon.element;
			return $('<span><span class="option-checkbox"><span class="option-checkbox__box"><i class="fas fa-check"></i></span></span>' + icon.text + '</span>');
		}
		$(".floorplan-select-filter").select2({
			tags: false,
			dropdownCssClass: 'checkbox-dropdown',
			templateResult: iformat,
		});

		$(".floorplan-select-filter").on("select2:unselect", function (evt) {
			if (!evt.params.originalEvent) { return; }
			evt.params.originalEvent.stopPropagation();
		});

		$(".select2-arrows").on('click', function(){
			$(this).closest(".floorplan-select-filter").select2('open');
		})

		$(".floorplans-results").select2({
			tags: false,
			minimumResultsForSearch: -1,
		});
		$(".select2-container").append('<div class="select2-arrows"><img class="select2-arrows__normal" src="https://dev.blackjetinteractive.com/2018/zibi/wp-content/themes/zibi-theme/assets/img/dropdown-toggles-dark.png"><img class="select2-arrows__hover" src="https://dev.blackjetinteractive.com/2018/zibi/wp-content/themes/zibi-theme/assets/img/dropdown-toggles-light.png"></div>');

		$(".floorplan-select-filter").on('change', (e) => {
			var val = $(e.currentTarget).val();
			var id = $(e.currentTarget).attr('id');
			this.filters[id] = val;
			this.setFilterdFloorplans();
			this.activeFloorPlan = this.filteredFloorplans[0];
			this.handleResults();
		});


		$(".floorplans-results").on('change', (e) => {
			var $selected = $(".floorplans-results option:selected");
			var index = $selected.index();
			var val = $(".floorplans-results").val();

			var obj = this.filteredFloorplans.filter(function(fp) {
				return fp.id == val;
			});

			this.activeFloorPlan = obj[0];
			this.activeFloorPlanIndex = index + 1;
			this.setMarkup();
		});

		$(".select2-arrows").on('click', function(){
			var $parent = $(this).closest('.filter-field, .slider-side__select-outer');
			var $select = $parent.find('select');
			if( !$parent.find('.select2-container').hasClass('select2-container--open') ) {
				$select.select2('open');	
			}
			else {
				$select.select2('close');
			}
			
		});

	}

	setFilterdFloorplans() {
		this.filteredFloorplans = [];
		for(var i in this.allFloorplans) {
			var floorplan = this.allFloorplans[i];
			var push = true;
			if( this.filters["condo"] && !this.filters["condo"].includes( String(floorplan.fp_data["condo"]) )  ) {
				push = false;
			}
			if( this.filters["price"] && !this.filters["price"].includes( String(floorplan.fp_data["price"]) )  ) {
				push = false;
			}
			if( this.filters["product-type"] && !this.filters["product-type"].includes( String(floorplan.fp_data["product-type"]) )  ){
				push = false;
			}
			if( this.filters["view"] && !this.filters["view"].includes( String(floorplan.fp_data["view"])  ) ){
				push = false;
			}

			if( push ) {
				this.filteredFloorplans.push(floorplan);
			}

		}

	}

	populateDropdown() {
		var data = [];
		var options = '';
		if( this.filteredFloorplans.length > 0 ) {
			this.floorPlansFound = true;
			for(var i in this.filteredFloorplans) {
				options += `<option value="${this.filteredFloorplans[i].id}">${this.filteredFloorplans[i].title.rendered}</option> `;
			}
		}
		else {
			options = '<option value="#">No Floorplans Available</option>';
			this.floorPlansFound = false;
		}
		$(".bjzm-select").html(options);
		this.activeFloorPlanIndex = 1;
	}

	handleResults() {
		this.setFilterdFloorplans();
		this.populateDropdown();
		this.setMarkup();
	}

	setDefaultFloorPlans() {
		var selectedFloorplans = this.getUrlVars()["condo-floorplans"] ? this.getUrlVars()["condo-floorplans"] : false;
		if( selectedFloorplans ) {
			var $option = $(`option[data-slug=${selectedFloorplans}]`);
			if( $option ) {
				var id = $option.data('id');
				var text = $option.text();
				$("#condo").val(id).trigger('change');
			}	
		}


	}

	numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}



	setMarkup() {

		if( !this.activeFloorPlan ) {
			$(".floorplans-details__data .fp-data");
			setTimeout(() => {
				$(".floorplans-details__data .fp-data").html('');
				$(".fp-pdf").attr('href', '');
				$(".fp-preview-list").html('');
				$(".fp-count").html(`Plans (0 of 0)`);
				$(".fp-condo-logo").attr('src', '' );
				$(".fp-condo-title").text('');
				$(".fp-condo-link").attr('href', '' );
				// $(".fp-floorplan-id").text('');
				setTimeout(function(){
					$(".fp-data").removeClass('change');
				}, 400);
			}, 500);
			return;
		}

		var priceString = BJZM_DATA.theme_strings['starting-from'].replace("%price%",this.numberWithCommas(this.activeFloorPlan.acf.starting_price) );
		var suiteString = BJZM_DATA.theme_strings['sq-ft'].replace("%feet%",this.activeFloorPlan.acf.suite_sqft );
		var balconyString = BJZM_DATA.theme_strings['sq-ft'].replace("%feet%",this.activeFloorPlan.acf.balcony_sqft );

		var addToListCta = this.myListFloorPlanIds.includes(this.activeFloorPlan.id) ? BJZM_DATA.theme_strings['remove-from-list'] : BJZM_DATA.theme_strings['add-to-list'];

		if(this.activeFloorPlan ) {
			$(".fp-data").addClass('change');
			var previewImages = this.getFloorPlanPreviewImages();
			setTimeout(() => {
				$(".fp-count").html(`Plans (${this.activeFloorPlanIndex} of ${this.filteredFloorplans.length})`);
				$(".fp-name").html(this.activeFloorPlan.title.rendered);
				$(".fp-price").html(priceString);
				$(".fp-beds").html(this.activeFloorPlan.acf.beds);
				$(".fp-baths").html(this.activeFloorPlan.acf.baths);
				$(".fp-suite-sqft").html(suiteString);
				$(".fp-balcony-sqft").html(balconyString);
				$(".fp-pdf").attr('href', this.activeFloorPlan.acf.pdf.url);
				$(".fp-preview-list").html(previewImages);
				if( $(".fp-preview-list").hasClass('slick-initialized') ) {
					$(".fp-preview-list").slick('destroy');
				}
				$(".fp-preview-list").slick({
					centerMode: false,
					dots: false,
					centerPadding: 0,
					slidesToShow: 1,
					variableWidth: false,
					arrows: false,
					infinite: true,
					adaptiveHeight: false,
					fade: true,
					autoplay: false,
					pauseOnHover: false,
					useCSS: true,
					cssEase: 'linear'
				});

				$(".fp-condo-logo").attr('src', this.activeFloorPlan.fp_data.condo_object.logo_dark.url );
				$(".fp-condo-title").text(this.activeFloorPlan.fp_data.condo_object.post_title)
				$(".fp-condo-link").attr('href', this.activeFloorPlan.fp_data.condo_object.permalink );
				$(".fp-floorplan-id").text(addToListCta);
				setTimeout(function(){
					$(".fp-data").removeClass('change');
				}, 400);
			}, 500);
		}	
	}

	handleNavClick() {
		$(".floorplans-details__preview-nav-link").on('click', function(e){
			e.preventDefault();
			var key = $(this).data('slide-key');
			$(this).parent().addClass('floorplans-details__preview-nav-item--active').siblings().removeClass('floorplans-details__preview-nav-item--active');
			$(".fp-preview-list").slick('slickGoTo', key);
		});
	}

	getFloorPlanPreviewImages() {
		var previewImages = '';
		for(var i in this.activeFloorPlan.acf.preview_images) {
			previewImages += `<li><img src="${this.activeFloorPlan.acf.preview_images[i].image.url }" class="floorplans-details__image fp-data fp-preview" /></li>`;
		}
		return previewImages;

	}

	getFloorPlanPreviewNav() {
		var previewImages = '';

		for(var i in this.activeFloorPlan.acf.preview_images) {
			var active = i == 0 ? 'floorplans-details__preview-nav-item--active' : '';
			previewImages += `<li class="floorplans-details__preview-nav-item ${active}">
			<a href="#" class="floorplans-details__preview-nav-link" data-slide-key="${i}">${this.activeFloorPlan.acf.preview_images[i].label}</a></li>`;
		}
		return previewImages;

	}

	handleData(data) {
		$(".bjzm-wrapper--floor-plans").removeClass('loading');
		this.allFloorplans = data;
		this.filteredFloorplans = data;
		this.activeFloorPlan = this.filteredFloorplans[0];
		setTimeout(function(){
			$(".planDetails, .planDetailsBottom").removeClass('loading');
		}, 500)
		this.populateDropdown();
		this.setMarkup();
		this.handleList();
		this.clickEvents();
		this.setDefaultFloorPlans();
	}

	clickEvents() {
		var self = this;
		$(".add-to-list").on('click', function(e){
			e.preventDefault();
			$(this).html(BJZM_DATA.theme_strings['remove-from-list']);
			var floorPlanId = self.activeFloorPlan.id;
			if( !self.myListFloorPlanIds.includes(floorPlanId) ) {
				self.handleAddToList(floorPlanId);
			}
			else {
				self.floorPlanToRemove = floorPlanId;
				$.magnificPopup.open({
					items: {
						src: '#fp-remove-confirm'
					},
					type: 'inline',
					removalDelay: 300,
					mainClass: 'mfp-img-mobile mfp-fade',

				});
			}
		});
		$(".email-my-list-button").on('click', function(e){
			e.preventDefault();
			$.magnificPopup.open({
				items: {
					src: '#my-list-popup'
				},
				callbacks: {
					open: function() {
						$('body').addClass('my-list-open');
					},
					close: function() {
						$('body').removeClass('my-list-open');
					}
				},
				type: 'inline',
				removalDelay: 300,
				mainClass: 'mfp-img-mobile mfp-fade',
			});
		});

		$(".close-mail-popup").on('click', function(e){
			e.preventDefault();
			$.magnificPopup.close({
				items: {
					src: '#my-list-popup'
				}
			});
		});
		/*close-mail-popup*/

		/*uncomment to show floorplan popup automatically*/
		/*$.magnificPopup.open({
			items: {
				src: '#my-list-popup'
			},
			type: 'inline'
		});
*/
		
		$(".casl-checkbox").on('change', function(){
			var val = $(this).val();
			var isChecked = $(this).prop('checked') == true;
			if( isChecked ) {
				$(this).closest('form').find('input[type="submit"]').addClass('ready-to-submit');
			}
			else {
				$(this).closest('form').find('input[type="submit"]').removeClass('ready-to-submit');
			}
		});

	}

	handleRemoveFromListClick() {
		var self = this;
		$(".card__fp-close").on('click', function(){
			var floorPlanId = $(this).data('floor-plan-id');
			self.floorPlanToRemove = floorPlanId;
			$.magnificPopup.open({
				items: {
					src: '#fp-remove-confirm'
				},
				type: 'inline',
				removalDelay: 300,
				mainClass: 'mfp-img-mobile mfp-fade',
			});
		});	
		$(".fp-alert__close").on('click', function(e){
			e.preventDefault();
			$.magnificPopup.close({
				items: {
					src: '#fp-remove-confirm'
				}
			});

		});	
		$(".confirm-floorplan-remove").on('click', function(e){
			e.preventDefault();
			self.handleRemoveFromList(self.floorPlanToRemove);	
			$(".fp-floorplan-id").text(BJZM_DATA.theme_strings['add-to-list']);
			$.magnificPopup.close({
				items: {
					src: '#fp-remove-confirm'
				}
			});
		});

		$('.bjzm-popup--my-list form').on('submit', function(e){
			$(".bjzm-popup--my-list  .bjzm-zibi-spinner-outer").addClass('show');	
			var email = $(".bjzm-popup--my-list input").val();
			self.sendMailList(email);
			e.stopImmediatePropagation();
    		// return false;
			// $(".bjzm-popup--my-list").addClass('loading');
		});

		jQuery(document).on('gform_confirmation_loaded', function(event, formId){
		    if( 9 == formId ) {
		    	$(".bjzm-popup--my-list .bjzm-popup__intro").hide();
		    	$(".bjzm-popup--my-list  .bjzm-zibi-spinner-outer").removeClass('show');	
		    }
		});
	}

	sendMailList(email) {

		var url = `${BJZM_DATA.ajaxurl}`;
		var retrievedFloorPlanIds = localStorage.getItem('myListFloorPlanIds');
		var floorPlanIds = JSON.parse(retrievedFloorPlanIds);
		axios.get(url, {
			params: {
				action: 'handleMyList',
				floorPlans: floorPlanIds,
				email: email
			}
		})
		.then(function (response) {
			console.log('response.data', response.data);
			gtag('event', 'conversion', {
				'allow_custom_scripts': true,
				'send_to': 'DC-9245067/invmedia/email0+unique'
			});
		})
		.catch(function (error) {
			console.log(error);
		}); 
	}

	handleAddToList(floorPlanId) {
		this.saveFloorplan(floorPlanId);
		this.buildMyList();
		this.setMyListMarkup();
	}

	handleRemoveFromList(floorPlanId) {

		var index = this.myListFloorPlanIds.indexOf(floorPlanId);
		if( index >= 0 ) {
			this.myListFloorPlanIds.splice(index, 1);
			localStorage.setItem('myListFloorPlanIds', JSON.stringify(this.myListFloorPlanIds));
			this.buildMyList();
			this.setMyListMarkup();
		}	

	}

	handleList() {``
		var retrievedFloorPlanIds = localStorage.getItem('myListFloorPlanIds');

		if( retrievedFloorPlanIds ) {
			this.myListFloorPlanIds = JSON.parse(retrievedFloorPlanIds);
		}

		if( this.myListFloorPlanIds.length ) {
			this.buildMyList();
		}	
		this.setMyListMarkup();

	}

	buildMyList() {
		this.myListFloorPlans = {};
		for( var i in this.myListFloorPlanIds ) {
			var obj = this.allFloorplans.filter((fp) => {
				return fp.id == this.myListFloorPlanIds[i];
			});

			this.myListFloorPlans[this.myListFloorPlanIds[i]] = obj[0];

		}

	}
	
	saveFloorplan( floorPlanId ) {
		this.myListFloorPlanIds.push(floorPlanId);
		localStorage.setItem('myListFloorPlanIds', JSON.stringify(this.myListFloorPlanIds));
		var retrievedFloorPlanIds = localStorage.getItem('myListFloorPlanIds');
	}


	setMyListMarkup() {
		var markup = '';
		var count = Object.keys(this.myListFloorPlans).length;
		var hasFaves = false;
		if( count > 0 ) {
			$(".fp-data--list-count").html(`(${count})`).addClass('change');
			$(".floorplans-mylist__half .button").removeClass('disabled');
		}
		else {
			markup = `<div class="no-list-outer"><p class="no-list">${BJZM_DATA.theme_strings['empty-my-list']}<p></div>`;
			$(".floorplans-mylist__half .button").addClass('disabled');
		}

		for(var i in this.myListFloorPlans) {
			if( this.myListFloorPlans[i] ) {
				markup += this.getListCard( this.myListFloorPlans[i] );
				hasFaves = true;
			}
		}
		markup += '<div class="card card--blog-post card--holder"></div>';
		if( hasFaves ) {
			$(".fp-my-list").html(markup);
		}

		setTimeout(function(){
			$(".fp-data").removeClass('change').removeClass('chamge');
		}, 400);
		this.handleRemoveFromListClick();
	}

	getListCard(floorPlan) {
		if(!floorPlan)
			return;
		var bedString = floorPlan.acf.beds ? BJZM_DATA.theme_strings['bed-count'].replace("%count%",floorPlan.acf.beds) + ', ' : '';
		var bathString = floorPlan.acf.baths ? BJZM_DATA.theme_strings['bath-count'].replace("%count%", floorPlan.acf.baths ) : '';
		var priceString = floorPlan.acf.starting_price ? BJZM_DATA.theme_strings['starting-from'].replace("%price%",this.numberWithCommas(floorPlan.acf.starting_price) ) : '';
		var card = `
		<article class="card card--blog-post card--floor-plan">
		<div class="card__inner">
		<span class="card__fp-close" data-floor-plan-id="${floorPlan.id}"></span>
		<div class="card__image-wrapper card-image">
		<div class="card__image card-image">
		<img class="card-image__image" src="${floorPlan.acf.preview_images[0].image.url}" alt="">
		<header class="card__header">
		<h4 class="card__title">${floorPlan.title.rendered}</h4>
		</header>
		</div>
		</div>
		<div class="card__wrap">
		<div class="card__content">
		<div class="card__excerpt">
		<p>${bedString}${bathString}<br />
		${priceString}
		</p>
		</div>
		</div>
		</div>
		</div>
		</article>
		`;

		return card;

	}

}














module.exports = FloorPlans;